import { connect } from 'react-redux'
import { detect } from 'detect-browser';
import { RenjuBoard } from '../../../components'
import { isNumber } from 'util';
import { SKIN } from '../../../constants';

const coordinateXString = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O']
const coordinateYString = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15']
const boxsize = 40;
const coordinateWidth = 40;
const starPoints = [{x: 3, y: 3}, {x: 3, y: 11}, {x: 7, y: 7}, {x: 11, y: 3}, {x: 11, y: 11}];
const browser = detect();

var textOffsetY = 0;
if (browser.name === 'edge') {
  textOffsetY = 5;
}

const mapStateToProps = (state, ownProps) => {
  const { disabled, type, moves, marks, movesHistory, movesAnalyze, forbiddenPosition, fiveMoves, cardWidth, analyzeStartNum, isAnalyzeMode, isSpecifiedWidth, isVisibleCoordinate, isVisibleNumber, isVisibleNextMove, isVisibleForbidden, skin } = ownProps
  var index, x1, y1, x2, y2, viewPort, rectProp, linesProp, starCircleProp, coordinateXProp, coordinateYProp, stonesProp, numbersProp, marksProp, forbiddenProp, fiveMovesProp, nextMoveProp, nextMove, boardWidth, boardHeight, scale, colorProp, lastMoveMarkProp, lastMove, filterMoves, clossProps, circleProps

  viewPort = '0 0 680 680'
  if (type && type === 'View'){
    viewPort = '30 30 620 620'
  }

  scale = 1 < cardWidth / 680 ? 1 : cardWidth / 680
  if (isSpecifiedWidth) {
    boardWidth = cardWidth.toString(10) + 'px'
    boardHeight = (640 * scale).toString(10) + 'px'
  }
  else {
    boardWidth = '100%'
    boardHeight = '100%'
  }
  linesProp = []
  numbersProp = []
  stonesProp = []
  clossProps = []
  circleProps = []

  switch (skin) {
    case SKIN.CARO: {
      colorProp = {
        board: disabled === true ? '#777777' : '#EEEEEE',
        line: disabled === true ? '#777777' : '#EEEEEE',
        fill: disabled === true ? '#777777' : '#EEEEEE',
        strings: disabled === true ? '#777777' : '#EEEEEE',
        coordinate: disabled === true ? '#777777' : '#777777',
      }
      for (index = 0; index < 14; index++){
        x1 = boxsize * (14 - index) + boxsize / 2;
        y1 = boxsize / 2;
        x2 = x1;
        y2 = boxsize * 16 - boxsize / 2;
        linesProp.push({ x1: x1 + coordinateWidth / 2, y1: y1 + coordinateWidth / 2, x2: x2 + coordinateWidth / 2, y2: y2 + coordinateWidth / 2 });
        linesProp.push({ x1: y2 + coordinateWidth / 2, y1: x1 + coordinateWidth / 2, x2: y1 + coordinateWidth / 2, y2: x2 + coordinateWidth / 2 });
      }
      rectProp = {
        x: boxsize / 2 + coordinateWidth / 2,
        y: boxsize / 2 + coordinateWidth / 2,
        width: boxsize * 15,
        height: boxsize * 15,
      }
      starCircleProp = []
      coordinateXProp = coordinateXString.map((str, index) => {
        return {
          x: index * boxsize + boxsize / 2 + coordinateWidth,
          y: boxsize * 15 + boxsize / 2 + textOffsetY + coordinateWidth,
          str: str,
        }
      })
      coordinateYProp = coordinateYString.map((str, index) => {
        return {
          x: boxsize / 2,
          y: (14 - index) * boxsize + boxsize / 2 + textOffsetY + coordinateWidth,
          str: str,
        }
      })
      clossProps = clossProps.concat(moves.filter((move, index) => move.color === 'black' && index >= 1).map((move, index) => {
        return {
          x: move.x * boxsize + boxsize / 2 + coordinateWidth / 2,
          y: move.y * boxsize + boxsize / 2 + coordinateWidth / 2,
        }
      }))
      circleProps = circleProps.concat(moves.filter((move, index) => move.color === 'white' && index >= 1).map((move, index) => {
        return {
          x: move.x * boxsize + boxsize / 2 + coordinateWidth / 2,
          y: move.y * boxsize + boxsize / 2 + coordinateWidth / 2,
        }
      }))
      numbersProp = moves.filter((move) => move.color === 'black' || move.color === 'white' ).map((move, index) => {
        var number, color
        number = move.number.toString(10)
        if (isAnalyzeMode){
          number = move.number - analyzeStartNum
        }
        color = ''
        if (move.color === 'black') {
          color = '#0071bc'
        }
        else if (move.color === 'white') {
          color = '#d1272d'
        }
        return {
          x: move.x * boxsize + boxsize * 3 / 4 + coordinateWidth,
          y: move.y * boxsize + boxsize * 3 / 4 + textOffsetY + coordinateWidth,
          color: color,
          number: number <= 0 ? '' : number.toString(10) ,
        }
      })
      filterMoves = moves !== undefined ? moves.filter(mv => 
        isNumber(mv.x) && isNumber(mv.y) && isNumber(mv.number) && mv.number > 0
      ) : undefined
      lastMove = filterMoves !== undefined && filterMoves.length > 0 ?
        filterMoves[filterMoves.length - 1] : undefined
      lastMoveMarkProp = lastMove !== undefined ? ({
        x: lastMove.x * boxsize + coordinateWidth + 1,
        y: lastMove.y * boxsize + coordinateWidth + 1,
        width: boxsize - 2,
        height: boxsize - 2,
        color: "yellow"
      }) : undefined
      marksProp = []
      if (marks) {
        marksProp = marks.map((mark) => {
          return {
            cx: mark.x * boxsize + boxsize / 2 + coordinateWidth,
            cy: mark.y * boxsize + boxsize / 2 + coordinateWidth,
            x: mark.x * boxsize + boxsize / 2 + coordinateWidth,
            y: mark.y * boxsize + boxsize / 2 + textOffsetY + coordinateWidth,
            str: mark.str,
          }
        })
      }
      stonesProp = []
      forbiddenProp = []
      fiveMovesProp = []
      break
    }
    default: {

      colorProp = {
        board: disabled === true ? '#777777' : '#222222',
        line: disabled === true ? '#777777' : '#222222',
        fill: disabled === true ? '#777777' : '#222222',
        strings: disabled === true ? '#777777' : '#222222',
        coordinate: disabled === true ? '#777777' : '#222222',
      }
      for (index = 0; index < 13; index++){
        x1 = boxsize * (13 - index) + boxsize / 2;
        y1 = boxsize / 2;
        x2 = x1;
        y2 = boxsize * 15 - boxsize / 2;
        linesProp.push({ x1: x1 + coordinateWidth, y1: y1 + coordinateWidth, x2: x2 + coordinateWidth, y2: y2 + coordinateWidth });
        linesProp.push({ x1: y2 + coordinateWidth, y1: x1 + coordinateWidth, x2: y1 + coordinateWidth, y2: x2 + coordinateWidth });
      }
      rectProp = {
        x: boxsize / 2 + coordinateWidth,
        y: boxsize / 2 + coordinateWidth,
        width: boxsize * 14,
        height: boxsize * 14,
      }
      starCircleProp = starPoints.map((starPoint) => {
        return {
          cx: starPoint.x * boxsize + boxsize / 2 + coordinateWidth,
          cy: starPoint.y * boxsize + boxsize / 2 + coordinateWidth
        }
      })
      coordinateXProp = coordinateXString.map((str, index) => {
        return {
          x: index * boxsize + boxsize / 2 + coordinateWidth,
          y: boxsize * 15 + boxsize / 2 + textOffsetY + coordinateWidth,
          str: str,
        }
      })
      coordinateYProp = coordinateYString.map((str, index) => {
        return {
          x: boxsize / 2,
          y: (14 - index) * boxsize + boxsize / 2 + textOffsetY + coordinateWidth,
          str: str,
        }
      })
      stonesProp = stonesProp.concat( moves.filter(move => move.x !== null && move.y !== null).map((move, index) => {
        return {
          cx: move.x * boxsize + boxsize / 2 + coordinateWidth,
          cy: move.y * boxsize + boxsize / 2 + coordinateWidth,
          r: 20,
          color: '#ffffff', 
        }
      }))
      stonesProp = stonesProp.concat( moves.filter(move => move.x !== null && move.y !== null).map((move, index) => {
        return {
          cx: move.x * boxsize + boxsize / 2 + coordinateWidth,
          cy: move.y * boxsize + boxsize / 2 + coordinateWidth,
          r: 19,
          color: colorProp.line,
        }
      }))
      stonesProp = stonesProp.concat(
        moves.filter((move, index) => move.color === 'white' && index >= 1)
        .map((move) => {
          return {
            cx: move.x * boxsize + boxsize / 2 + coordinateWidth,
            cy: move.y * boxsize + boxsize / 2 + coordinateWidth,
            r: 17.5,
            color: '#ffffff',
          }
        })
      )
      numbersProp = moves.filter((move) => move.color === 'black' || move.color === 'white' ).map((move, index) => {
        var number, color
        number = move.number.toString(10)
        if (isAnalyzeMode){
          number = move.number - analyzeStartNum
        }
        color = ''
        if (move.color === 'black') {
          color = '#ffffff'
        }
        else if (move.color === 'white') {
          color = colorProp.strings
        }
        return {
          x: move.x * boxsize + boxsize / 2 + coordinateWidth,
          y: move.y * boxsize + boxsize / 2 + textOffsetY + coordinateWidth,
          color: color,
          number: number <= 0 ? '' : number.toString(10) ,
        }
      })
      
      filterMoves = moves !== undefined ? moves.filter(mv => 
        isNumber(mv.x) && isNumber(mv.y) && isNumber(mv.number) && mv.number > 0
      ) : undefined
      lastMove = filterMoves !== undefined && filterMoves.length > 0 ?
        filterMoves[filterMoves.length - 1] : undefined
      lastMoveMarkProp = lastMove !== undefined ? ({
        cx: lastMove.x * boxsize + boxsize / 2 + coordinateWidth,
        cy: lastMove.y * boxsize + boxsize / 6 + coordinateWidth,
        r: 2,
        color: lastMove.color === 'black' ? '#ffffff' : colorProp.fill
      }) : undefined
      
      marksProp = []
      if (marks) {
        marksProp = marks.map((mark) => {
          return {
            cx: mark.x * boxsize + boxsize / 2 + coordinateWidth,
            cy: mark.y * boxsize + boxsize / 2 + coordinateWidth,
            x: mark.x * boxsize + boxsize / 2 + coordinateWidth,
            y: mark.y * boxsize + boxsize / 2 + textOffsetY + coordinateWidth,
            str: mark.str,
          }
        })
      }
    
      forbiddenProp = []
      if (forbiddenPosition && isVisibleForbidden) {
        forbiddenProp = forbiddenPosition.map(forbidden => {
          return {
            cx: forbidden.x * boxsize + boxsize / 2 + coordinateWidth,
            cy: forbidden.y * boxsize + boxsize / 2 + coordinateWidth,
            x: forbidden.x * boxsize + boxsize / 2 + coordinateWidth,
            y: forbidden.y * boxsize + boxsize / 2 + textOffsetY + coordinateWidth,
          }
        })
      }
      
      fiveMovesProp = []
      if (fiveMoves) {
        fiveMovesProp = fiveMoves.map(move => {
          return {
            cx: move.x * boxsize + boxsize / 2 + coordinateWidth,
            cy: move.y * boxsize + boxsize / 2 + coordinateWidth,
          }
        })
      }
    
      if (isAnalyzeMode){
        if (isVisibleNextMove) {
          if (movesAnalyze.length > moves.length){
            nextMove = movesAnalyze[moves.length];
          }
        }
      }
      else {
        if (isVisibleNextMove) {
          if (movesHistory.length > moves.length){
            nextMove = movesHistory[moves.length];
          }
        }
      }
      if (nextMove && nextMove.x !== null && nextMove.y !== null) {
        nextMoveProp = {
          cx: nextMove.x * boxsize + boxsize / 2 + coordinateWidth,
          cy: nextMove.y * boxsize + boxsize / 2 + coordinateWidth,
        }
      }
      else {
        nextMoveProp = null
      }
    }
  }

  return ({
    viewPort,
    boardWidth,
    boardHeight,
    nextMove,
    rectProp,
    linesProp,
    starCircleProp,
    coordinateXProp,
    coordinateYProp,
    stonesProp,
    numbersProp,
    marksProp,
    forbiddenProp,
    fiveMovesProp,
    nextMoveProp,
    colorProp,
    lastMoveMarkProp,
    isVisibleNumber,
    isVisibleCoordinate,
    isVisibleNextMove,
    clossProps,
    circleProps,
  })
}

export default connect(
  mapStateToProps,
)(RenjuBoard)



// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoard/RenjuBoard.js